/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */
import { l } from '@atproto/lex-schema';
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js';
const $nsid = 'org.okazu-diary.actor.profile';
export { $nsid };
/** A declaration of an Okazu-Diary.org profile. If the repository has an `app.bsky.actor.profile` record, the application may substitute omitted properties of this record with the counterpart properties from that record, except for those not defined in the bsky Lexicon and the `createdAt` and `labels` properties. An empty string or `null` does not count as "omitted". */
const main = /*#__PURE__*/ l.record('literal:self', $nsid, 
/*#__PURE__*/ l.object({
    displayName: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.nullable(
    /*#__PURE__*/ l.string({ maxGraphemes: 64, maxLength: 640 }))),
    description: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.nullable(
    /*#__PURE__*/ l.string({ maxGraphemes: 256, maxLength: 2560 }))),
    website: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.nullable(/*#__PURE__*/ l.string({ format: 'uri' }))),
    avatar: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.nullable(
    /*#__PURE__*/ l.blob({
        accept: ['image/png', 'image/jpeg'],
        maxSize: 1000000,
    }))),
    labels: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.nullable(
    /*#__PURE__*/ l.typedUnion([
        /*#__PURE__*/ l.typedRef((() => LabelDefs.selfLabels)),
    ], false))),
    lang: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'language' })),
    alsoKnownAs: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'at-uri' }))),
    createdAt: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.nullable(/*#__PURE__*/ l.string({ format: 'datetime' }))),
}));
export { main };
const $type = $nsid;
export { $type };
export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main);
export const $build = /*#__PURE__*/ main.build.bind(main);
export const $assert = /*#__PURE__*/ main.assert.bind(main);
export const $check = /*#__PURE__*/ main.check.bind(main);
export const $cast = /*#__PURE__*/ main.cast.bind(main);
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main);
export const $matches = /*#__PURE__*/ main.matches.bind(main);
export const $parse = /*#__PURE__*/ main.parse.bind(main);
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main);
export const $validate = /*#__PURE__*/ main.validate.bind(main);
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main);
//# sourceMappingURL=profile.defs.js.map